/*
 * @Author: gaobin
 * @Date: 2025-03-13 18:11:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-28 14:56:12
 * @Description: 请填写简介
 */
import { useLoading } from '@/composables/useGlobalLoading';
import { i18n } from '@/locale';
import store from '@/store';
import { showToast } from '@subs-utils';
import { CUR_PLATFORM, TIMEOUT } from '@utils/constant';
import { v4 as uuidv4 } from 'uuid';
import commonMap from './api/common';

const { hideLoading } = useLoading();

const { t } = i18n.global;
const countErr = [400, 401, 403, 404, 406, 410, 422, 500, 502, 503, 504];

const generateTrackingId = uuidv4().replace(/-/g, ''); // 生成一个随机的UUID

function getBaseURL(headers) {
  let baseURLTemp = '';
  // #ifdef H5
  if (import.meta.env.VITE_UWEBUY_APP_ENV === 'prod') {
    baseURLTemp = 'https://www.sharerclub.com';
  } else if (import.meta.env.VITE_UWEBUY_APP_ENV === 'test') {
    baseURLTemp = 'https://test-u-app.pandapon.com';
  } else if (import.meta.env.VITE_UWEBUY_APP_ENV === 'dev') {
    baseURLTemp = 'https://dev-s-app.pandapon.com';
  } else if (import.meta.env.VITE_UWEBUY_APP_ENV === 'k8sdev') {
    baseURLTemp = 'https://dev-uwb-app.pandapon.com';
  } else {
    // baseURLTemp = 'https://dev-s-app.pandapon.com';
    // baseURLTemp = 'http://192.168.1.126:8080'; // 水榭
    baseURLTemp = 'https://www.sharerclub.com';
  }
  // #endif

  // #ifdef APP-PLUS
  const isDev = uni.getStorageSync('UWEBUY_APP_IS_DEV');

  if (isDev) {
    baseURLTemp = 'https://dev-u-app.pandapon.com';
    // baseURLTemp = 'http://192.168.0.196:8080';
    // baseURLTemp = 'http://192.168.1.34:8080';
    // baseURLTemp = 'http://dev-uwb-app.pandapon.com';
    // baseURLTemp = 'http://192.168.1.5:8080'; // 曹宇
    // baseURLTemp = 'http://192.168.0.1:32279';
    // baseURLTemp = 'http://192.168.0.195:8080';
    // baseURLTemp = 'http://192.168.1.34:8080';
    // baseURLTemp = 'http://192.168.1.51:8080'; // 张瑞祥
    // baseURLTemp = 'http://192.168.1.34:8080'; // 黄涛
    // 聊天室测试
    // baseURLTemp = 'http://dev-fans-scrm.pandapon.com';
    baseURLTemp = 'https://test-pandapon-core-service.pandapon.com';
  } else {
    // baseURLTemp = 'http://192.168.1.5:8080'; // 曹宇
    // baseURLTemp = 'http://dev-uwb-app.pandapon.com';
  }
  // #endif

  // 连接他人本地电脑联调时有用
  const regex = /^http:\/\/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(\/|$)/i;
  if (regex.test(baseURLTemp)) {
    baseURLTemp.replace(/^(\/usb|\/fanscrm)/, '');
  }

  return baseURLTemp;
}

async function getHeaders(headers) {
  const newHeaders = {
    channel: '9',
    'user-type': '2',
  };

  // const token = '09302c4e-bfce-47bd-b22f-6287d085b722';
  const { token, lang, utmSource } = store.getters;
  if (token) {
    newHeaders.Authorization = `Bearer ${token}`;
  }

  if (utmSource) {
    newHeaders['utm-source'] = utmSource;
  }

  newHeaders.language = lang || 'en';
  newHeaders.currency = 'SAR';
  if (!uni.getStorageSync('TRACE_ID')) {
    uni.setStorageSync('TRACE_ID', generateTrackingId);
  }
  newHeaders['X-Trace-Id'] = uni.getStorageSync('TRACE_ID');

  newHeaders.platform = CUR_PLATFORM;

  // console.log('333', uni.getStorageSync('PRODUCT_ID'));
  if (uni.getStorageSync('PRODUCT_ID')) {
    newHeaders['d-trace-id'] = uni.getStorageSync('PRODUCT_ID');
  }

  return {
    ...newHeaders,
    ...(headers || {}),
  };
}

const pending = []; // 用来记录队列中的请求

// 判断是否有重复的请求并移除
// const removePending = (config) => {
//   for (let p = 0; p < pending.length; p++) {
//     // console.log('正在请求中', pending);
//     if (pending[p].u === `${config.url?.split('?')[0]}&${config.method}`) {
//       // 当当前请求在数组中存在时执行函数体
//       pending[p].requestTask.abort();
//       pending.splice(p, 1); // 数组移除当前请求
//     }
//   }
// };

// 关闭轻提示
const closeAllToast = () => {
  // 失败了就清空一下toast
  uni.hideToast();
  hideLoading();

  // #ifdef APP-PLUS
  plus.nativeUI.closeToast();
  // #endif
};

// 普通请求
const request = async (
  url,
  {
    method = 'post',
    timeout = TIMEOUT,
    data = {},
    headers = { 'Content-Type': 'application/json' },
    bHiddenError = false, // 是否隐藏错误提示
    judgeTokenExpired = false, // 是否判断token过期
  },
) => {
  const newHeaders = await getHeaders(headers);
  const baseURL = getBaseURL();
  const sendUrl = baseURL + url;

  return new Promise((resolve, reject) => {
    // 每次发送请求之前判断一下
    // removePending({
    //   url,
    //   method,
    //   timeout,
    //   data,
    //   headers,
    // });

    try {
      // const requestTask =
      uni.request({
        url: sendUrl,
        method,
        data,
        timeout,
        header: newHeaders,
        success(res) {
          const { code, success } = res?.data || {};
          switch (code) {
            case 401: {
              const pages = getCurrentPages();
              const curPageRoute = pages?.[pages.length - 1]?.$page?.fullPath;
              if (curPageRoute?.includes('/pages/login/index')) return;
              store.dispatch('Logout');
              if (judgeTokenExpired) {
                // 退出登录 不跳转登录页
                // 主要是为了 token过期 但是不需要跳转登录页的情景 比如个人中心页面
                break;
              }
              setTimeout(() => {
                uni.redirectTo({
                  url: `/pages/login/index?redirect=${encodeURIComponent(curPageRoute || '')}`,
                });
              }, 100);

              break;
            }
            default: {
              hideLoading();
              if (success) {
                resolve(res.data);
              } else {
                if (!bHiddenError) {
                  showToast({
                    title: countErr.includes(res?.data?.code)
                      ? t(res?.data?.code)
                      : res?.data?.message,
                    type: 'fail',
                  });
                }
                reject(res);
              }
              break;
            }
          }
        },
        fail(err) {
          // 失败了就清空一下toast
          closeAllToast();

          reject(err);
        },
        complete: (res) => {
          // 从请求队列中移除已经执行完成的请求
          // const removeIndex = pending.findIndex((item) => item.requestTask === requestTask);
          // pending.splice(removeIndex, 1);
        },
      });
    } catch (error) {
      showToast({
        title: JSON.stringify(error),
        type: 'fail',
      });
      setTimeout(() => {
        closeAllToast();
      }, 1000);
      reject(error);
    }

    // 把请求加入队列数组中
    // pending.push({
    //   u: `${url?.split('?')[0]}&${method}`,
    //   requestTask,
    // });
  });
};

// 上传图片
const uploadFile = async (url, data) => {
  const newHeaders = await getHeaders();
  const baseURL = getBaseURL();

  return new Promise((resolve, reject) => {
    try {
      uni.uploadFile({
        url: `${baseURL}${url || commonMap?.uploadFileExt}`,
        header: newHeaders,
        name: 'file',
        filePath: data?.file,
        formData: data?.formData,
        success: (uploadRes) => {
          console.log('上传结果', uploadRes);
          // 不管怎样都将toast清除一下
          closeAllToast();

          const resData = JSON.parse(uploadRes?.data || '{}');
          if (resData.success) {
            resolve(resData);
          } else {
            showToast({
              title: resData?.message || t('shangChuanShiBai'),
              icon: 'fail',
            });
            reject(resData);
          }
        },
        fail: (err) => {
          // 不管怎样都将toast清除一下
          closeAllToast();

          showToast({
            title: err?.message || t('shangChuanShiBai'),
            icon: 'fail',
          });
          reject(err);
        },
      });
    } catch (error) {
      showToast({
        title: JSON.stringify(error),
        type: 'fail',
      });
      setTimeout(() => {
        closeAllToast();
      }, 1000);
      reject(error);
    }
  });
};

export default {
  request,
  uploadFile,
  getBaseURL,
};
